import { Input } from 'component/Input'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { EmailFormStore } from 'store/profile/EmailFormStore'

type Props = {
  it: EmailFormStore
}

export const EmailInput = observer(({ it }: Props) => {
  const { touch, email, error } = it
  const showError = touch && !!error

  const onRef = useLatestCallback((element: HTMLInputElement | null) => {
    it.element = element ?? undefined
  })

  const onChange = useLatestCallback((value: string) => {
    it.email = value
  })

  return <Vertical>
    {opt.tsum && <Typo size={12} secondary>{i18n('EmailLabel')}</Typo>}
    <Input ref={onRef} large panel={!opt.tsum} error={showError} value={email}
      placeholder={i18n('EmailPlaceholder')} onChange={onChange} />
    {showError && <Gap height={8} />}
    {showError && <Typo size={15} error>{error}</Typo>}
  </Vertical>
})
